import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class RoleService {
  static loadRoles() {
    const url = `${endpoints.BASE_URL}${endpoints.ROLES}`;

    return axios.get(url).then((response) => response.data);
  }

  static getRole(id) {
    const url = `${endpoints.BASE_URL}${endpoints.ROLES}/${id}`;

    return axios.get(url).then((response) => response.data);
  }

  static createRole(role) {
    const url = `${endpoints.BASE_URL}${endpoints.ROLES}`;
    const body = {
      role
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateRole(role) {
    const url = `${endpoints.BASE_URL}${endpoints.ROLES}/${role.id}`;
    const body = {
      role
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deleteRole(id) {
    const url = `${endpoints.BASE_URL}${endpoints.ROLES}/${id}`;
    return axios.delete(url).then((response) => response.data);
  }
}

export default RoleService;
